import authService from 'core/auth/auth-service'
import NoRecords from 'core/no-records/no-records-container'
import { TFunction } from 'i18next'
import qs from 'qs'
import { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Device from './Device'
import { ClearCurrentDeviceFunction, GetDeviceFunction, RTFDeviceData } from './redux/devices/types'
import { GetAssetsValuesAndSetSettingsFunction, RTFSettingsState } from './redux/settings/types'
import SettingsComponent from './Settings/SettingsComponent'

type RTFProps = {
  getDevice: GetDeviceFunction
  clearCurrentDevice: ClearCurrentDeviceFunction
  currentDevice: RTFDeviceData
  t: TFunction
  getAssetsValuesAndSetSettings: GetAssetsValuesAndSetSettingsFunction
  settings: RTFSettingsState
  clearHistory: () => void
}

export type OnGetDeviceCallback = (deviceId: string) => void

function getDeviceIdFromLocation(search: string) {
  if (search) {
    const searchObject = qs.parse(search)
    return { deviceId: searchObject['?deviceId'] || '' } as { deviceId: string }
  }

  return { deviceId: '' }
}

export default function rtfComponent({ getDevice, currentDevice, t, clearCurrentDevice, settings, getAssetsValuesAndSetSettings, clearHistory }: RTFProps) {
  const location = useLocation()
  const { deviceId } = getDeviceIdFromLocation(location.search)

  useEffect(() => {
    if (authService.getCurrentOpco() !== settings.assetsValuesOPCO) {
      getAssetsValuesAndSetSettings()
    }

    if (deviceId && settings.assetsValuesOPCO) {
      getDevice(deviceId)
    }

    return () => {
      clearCurrentDevice()
    }
  }, [deviceId, settings.assetsValuesOPCO])

  const onGetDevice = useCallback((deviceId: string) => {
    window.location.href = `/operational/rtf?deviceId=${deviceId}`
    clearHistory()
  }, [])

  const setTabReference = useCallback((selectedTab: string) => {
    const url = new URL(window.location.href)
    url.searchParams.set('tab', selectedTab.toLowerCase())
    window.history.pushState(null, '', url.toString())
  }, [])


  return (
    <div className="tile is-parent">
      <div className="tile is-child">
        <Device onGetDevice={onGetDevice} deviceIdQuery={deviceId} />
        <div>
          {currentDevice.udid ?
            <SettingsComponent currentDevice={currentDevice} settings={settings} setTabReference={setTabReference} /> :
            <NoRecords subtitle={t('rtf.search_device')} />}
        </div>
      </div>
    </div>
  )
}
